// Utility function: check for subscription products
function hasSubscriptionProduct(cart) {
  return cart.items.some(item =>
    item.selling_plan_allocation &&
    item.selling_plan_allocation.selling_plan &&
    /1 Month|3 Month|6 Month|3 Months|6 Months/i.test(item.selling_plan_allocation.selling_plan.name)
  );
}

// Utility: check if special product exists
function hasSpecialProduct(cart) {
  return cart.items.some(item => item.product_id === 9832961835305);
}

// Function to hide/show campaign divs
function toggleCampaignDivs(cart) {
  const elements = document.querySelectorAll(".bmsm-milestone-trigger");

  elements.forEach(el => {
    if (el.textContent.trim() === "$1") {
      el.textContent = "CapSole Club";
    }
  });

  var div871 = document.getElementById('871');
  var div873 = document.getElementById('873');
  var div872 = document.getElementById('872');
  var div874 = document.getElementById('874');
  var div931 = document.getElementById('913');

  console.log("here");

  // If special product is found
  if (hasSpecialProduct(cart)) {
    if (div871) div871.style.display = 'none';
    if (div873) div873.style.display = 'none';
    if (div872) div872.style.display = 'none';
    if (div874) div874.style.display = 'none';
    if (div931) div931.style.display = 'block';
    return; // stop here, don't run subscription logic
  }

  // If special product NOT found → hide 931, continue with subscription logic
 if(div931){
div931.style.display = 'none';
 }
 

  //}
  if (!div871 && !div873) return; // Nothing to hide/show

  if (hasSubscriptionProduct(cart)) {
    if (div871) div871.style.display = 'none';
    if (div873) div873.style.display = 'none';
    if (div872) div872.style.display = 'block';
    if (div874) div874.style.display = 'block';
  } else {
    if (div871) div871.style.display = 'block';
    if (div873) div873.style.display = 'block';
    if (div872) div872.style.display = 'none';
    if (div874) div874.style.display = 'none';
  }
}

// Fetch cart on page load
function fetchCartAndToggle() {
  console.log("fetched");
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      setTimeout(() => toggleCampaignDivs(cart), 700); // 0.7 sec delay
    })
    .catch(err => console.error('Error fetching cart:', err));
}

// Run on page load
document.addEventListener('DOMContentLoaded', fetchCartAndToggle);

async function fetchCart() {
  const response = await fetch('/cart.js');
  return response.json();
}

async function emitCartChanges() {
  const newCart = await fetchCart();
  const event = new CustomEvent("cart_changed", { detail: newCart });
  window.dispatchEvent(event);
}

function observeCartChanges() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\//.test(entry.name);
      if (isValidRequestType && isCartChangeRequest) {
        emitCartChanges();
      }
    });
  });

  cartObserver.observe({ entryTypes: ["resource"] });
}
observeCartChanges();

window.addEventListener("cart_changed", e => {
  var cart_data = e.detail;
  setTimeout(() => toggleCampaignDivs(cart_data), 1000); // 0.7 sec delay
});